export const host = "http://master.hunterwave.com/scarping-0.0.1-SNAPSHOT";

// export const apiurl = "http://localhost:8080";
// export const apiurl = "http://54.185.91.234:8080";
export const apiurl = "https://vacationjavaapi.travomint.com";
// export const apiurl = "http://10.20.1.4:8090";
// export const apiurl = "http://34.223.182.130:8080";
export const authCode = "Trav1124-APAR07";
export const siteId = "1";
